import React from "react";

const firmasE = [
  { title: "Deudor", value: "_______________" },
  { title: "Documento", value: "_______________" },
  { title: "Dirección IP", value: "_______________" },
  { title: "Fecha y hora", value: "_______________" },
  { title: "Firma Electrónica", value: "_______________" },
];

export function FirmaE({ title = "Firma" }) {
  return (
    <div>
      <div className="mt-4">
        <div>
          <h2 className="uppercase font-bold">{title}</h2>
        </div>
        <div className="mt-4">
          {firmasE.map((firmaE, idx) => (
            <ul key={idx} className="grid grid-cols-5">
              <div className="col-span-2">
                <li>{firmaE.title}</li>
              </div>
              <div className="col-span-3 ml-2">
                <span> {firmaE.value} </span>
              </div>
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}
